import secondaryComponents from "../../../../../components/secondaryComponents";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { motion } from "framer-motion";
import { IntegratedTerminalForm } from "../../../../../components/secondaryComponents/IntegratedTerminals";
import { useAddIntegratedTerminals } from "../AddIntegratedTerminals/useAddIntegratedTerminals";
import { useParams } from "react-router-dom";
import { useGetTerminalsDetails } from "../../../../../hooks/api/queries/useTerminals";

export const EditIntegratedTerminals = () => {
  const { isLoading: isFetchingBusiness, ...rest } =
    useAddIntegratedTerminals();
  const { id } = useParams();
  const { data: terminalDetails, isLoading: isFetchingTerminalDetails } =
    useGetTerminalsDetails({ id });

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Market - Connect Business"
      description="Manage business connections"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles.pagePaddings} ${globalStyles.pageColumnGaps}`}
        >
          <secondaryComponents.LoaderHelper
            isLoading={isFetchingTerminalDetails || isFetchingBusiness}
          >
            <IntegratedTerminalForm
              terminalDetails={terminalDetails}
              isEditMode={true}
              {...rest}
            />
          </secondaryComponents.LoaderHelper>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
